import httpClient from "./httpClient";
import { getApiBaseUrl } from "../data/authStorage";
const base = `${getApiBaseUrl()}/organizations/calendar-events`;
export const listCalendarEvents = (params) => httpClient.get(base, { params }).then((r) => r.data);
export const createCalendarEvent = (payload) => httpClient.post(base, payload).then((r) => r.data);
export const updateCalendarEvent = (id, payload) => httpClient.patch(`${base}/${id}`, payload).then((r) => r.data);
export const deleteCalendarEvent = (id) => httpClient.delete(`${base}/${id}`).then((r) => r.data);
